// These would be imported from appropriate files
import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { ParamContext } from '../../../shared/service/param.context';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from '../../../app.constants';
import { EnableLoadingIndicator, EnablePageBlocking, EnableSavingIndicator } from '../../../shared/loading-indicator';

export class VariableDataset {
    id: number;
    name: string;
    description: string | null;
    programUUID: string | null;
    folder: boolean;
    study: boolean;
}

export class Variable {
    variableName: string;
    datasets: VariableDataset[];
}

export class VariablesDatasetsMap {
    [key: string]: Variable;
}

@Injectable({
    providedIn: 'root'
})
export class DerivedVariableService {
    isStudyHasCalculatedVariables = true;

    constructor(
        private http: HttpClient,
        private context: ParamContext
    ) {
    }

    //  /**
    // * Checks if the variable IDs have measurement data
    // */
    //  hasMeasurementData(variableIds: number[]): Observable<any> {
    //      const url = `${SERVER_API_URL}DerivedVariableController/derived-variable/dependencyVariableHasMeasurementData/`;
    //      return this.http.post(url, variableIds);
    //  }

    /**
     * Calculates variable for sub-observation
     */
    calculateVariableForSubObservation(studyId: number, datasetId: number, calculateData: any): Observable<{ hasDataOverwrite?: boolean, inputMissingData?: string }> {
        const baseUrl = `${SERVER_API_URL}crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/`;
        const url = `${baseUrl}${studyId}/datasets/${datasetId}/derived-variables/calculation`;
        return this.http.post(url, calculateData, { context: new HttpContext().set(EnableSavingIndicator, true).set(EnablePageBlocking, true) });
    }

    /**
     * Gets missing formula variables
     */
    getMissingFormulaVariables(studyId: number, datasetId: number, variableId: number): Observable<any> {
        const baseUrl = `${SERVER_API_URL}crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/`;
        const url = `${baseUrl}${studyId}/datasets/${datasetId}/derived-variables/${variableId}/formula-variables/missing`;
        return this.http.get(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    /**
     * Gets formula variable dataset map
     */
    getFormulaVariableDatasetMap(studyId: number, datasetId: number, variableId: number): Observable<VariablesDatasetsMap> {
        const baseUrl = `${SERVER_API_URL}crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/`;
        const url = `${baseUrl}${studyId}/datasets/${datasetId}/derived-variables/${variableId}/formula-variables/dataset-map`;
        return this.http.get<VariablesDatasetsMap>(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    /**
     * Gets formula variables for a dataset
     */
    getFormulaVariables(studyId: number, datasetId: number): Observable<any> {
        const baseUrl = `${SERVER_API_URL}crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/`;
        const url = `${baseUrl}${studyId}/datasets/${datasetId}/derived-variables/formula-variables`;
        return this.http.get(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    /**
     * Counts calculated variables
     */
    countCalculatedVariables(studyId: number, datasetIds: number[]): Observable<HttpResponse<any>> {
        const baseUrl = `${SERVER_API_URL}crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/`;
        const url = `${baseUrl}${studyId}/derived-variables`;
        return this.http.head<any>(url, {
            params: { datasetIds: datasetIds.join(',') },
            observe: 'response',
            context: new HttpContext().set(EnableLoadingIndicator, true)
        });
    }
}
